module.exports = __webpack_public_path__ + "static/img/btn_jfsc.58f0099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/btn_jfsc.png
// module id = V5wm
// module chunks = 1